module.exports = __webpack_public_path__ + "img/lookbook_5_center.54c0629b.png";